import { _device } from '../m_base/util'
import { RewardJsInstall }  from '../../api/index'

window.mtg_fn_install = function(){
  let params = window.GLOBAL_DATA

  if(_device().isiOS){
    params = encodeURIComponent(JSON.stringify(params))
  }

  RewardJsInstall(params)
}